var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQualys(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "idv2oXT8IT_logos 2",
    clipPath: "url(#clip0_4564_63607)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.48954 0.480469C7.2258 0.480469 8.60076 1.94413 8.60076 1.94413C8.60076 1.94413 8.7577 3.02568 8.65876 5.20923C8.50864 8.50503 4.49295 10.4805 4.49295 10.4839C4.49295 10.4873 0.473841 8.50162 0.323722 5.20923C0.221367 3.02568 0.37831 1.94413 0.37831 1.94413C0.37831 1.94413 1.75327 0.480469 4.48954 0.480469Z",
    fill: "#ED2E26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.43615 4.81076C2.43615 3.64734 3.35733 2.69885 4.49005 2.69885C5.62277 2.69885 6.54396 3.62004 6.54396 4.75276C6.54396 5.65689 5.76607 6.40066 5.169 6.78278C5.401 6.91584 5.91277 7.05573 6.40407 7.10008C7.13079 6.53713 7.55726 5.67054 7.55726 4.75276C7.56409 3.05709 6.19254 1.67872 4.49688 1.6719C2.80121 1.66508 1.42284 3.03662 1.41602 4.73229C1.41602 4.73911 1.41602 4.74594 1.41602 4.75276C1.41602 5.7763 1.84249 6.68384 2.64768 7.37985C3.40169 8.0315 4.50029 8.4648 5.75583 8.66951C6.02878 8.51939 6.49278 8.07586 6.66678 7.81656C5.61936 7.6835 4.62994 7.42761 3.96463 7.07961C2.95133 6.54737 2.43615 5.78312 2.43615 4.81076Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4564_63607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.39986,
    height: 10,
    fill: "white",
    transform: "translate(0.289062 0.480469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualys);
export default __webpack_public_path__ + "static/media/Qualys.9546b50dfca647503130673d5f58aca6.svg";
export { ForwardRef as ReactComponent };